export const dateSort = () => {
  return function (a, b) {
    if (a.node.posted_at > b.node.posted_at) return -1;
    if (a.node.posted_at < b.node.posted_at) return 1;
    return 0;
  };
};
